import React from 'react';
import PropTypes from 'prop-types';
import labels from '../i18n';

const EmptyComponent = (props) => {
  const {
    lang,
    title,
    mode,
    phdLink,
  } = props;
  return (
    <div className="row">
      <div className="column large-12 medium-12 small-12">
        <div className="au-vacancy-filter-container empty">
          <h1>
            <span dangerouslySetInnerHTML={{ __html: labels[lang].empty }} />
            {` ${title === '' ? '' : ` ${labels[lang].on} `} ${title}`}
          </h1>
          {(() => {
            if (mode !== 'main') {
              return <a className="button empty" href={labels[lang].emptyBtnLink}>{labels[lang].emptyBtnLabel}</a>;
            }
            return null;
          })()}
          <a className="button empty phd" href={phdLink}>{labels[lang].filterButtons.phd}</a>
        </div>
        { /*
        <div className="au-vacancies-jobagent">
          <div>
            <h3>{labels[lang].jobbankHeader}</h3>
            <p>
              {labels[lang].jobbankText}
            </p>
          </div>
          <a href={labels[lang].jobbankLink} className="button bg-magenta">
            {labels[lang].jobbankLinkText}
          </a>
        </div> */
        }
      </div>
    </div>
  );
};

EmptyComponent.propTypes = {
  lang: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  phdLink: PropTypes.string.isRequired,
};

EmptyComponent.displayName = 'EmptyComponent';
export default EmptyComponent;
